import styled from '../../components-v4/theme/styled';
import locationPhone from '../../assets/locationPhone.svg';

export const GradientWrapper = styled.div<{ isMobile: boolean }>`
  min-height: ${(props) => (props.isMobile ? '60px' : '80px')};
  flex-shrink: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(
    90deg,
    ${(props) => props.theme.colors.green[700]} 0%,
    ${(props) => props.theme.colors.green[200]} 100%
  );
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    right: -10px;
    top: 50%;
    width: 180px;
    height: 70px;
    background-color: ${(props) => props.theme.colors.green[500]};
    mask-image: url(${locationPhone});
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    -webkit-mask-image: url(${locationPhone});
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;
    transform: translateY(-50%) rotate(15deg);
    opacity: 0.6;
    pointer-events: none;
  }

  & > * {
    position: relative;
    z-index: 1;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const PhonesRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const PhoneItem = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const NumberChip = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  box-sizing: border-box;
`;
